import { Injectable } from '@angular/core';

import { BaseApiService } from '@shared/services/api';
import { portalEnvironment } from '../../../../environments/environment';
import { PortalFormioTokenResponse } from '../models/auth.model';

/**
 * API service for retrieving Formio tokens for the portal application.
 *
 * Mirrors the legacy portal behavior of calling `/auth/refreshToken`
 * on the portal API and returning a Formio JWT plus its expiration.
 *
 * This service is intended to be provided at the route level alongside
 * features that require Formio (e.g., dashboard, patient forms).
 */
@Injectable()
export class PortalFormioAuthApi extends BaseApiService<PortalFormioTokenResponse> {
  constructor() {
    super(portalEnvironment.apiUrl);
  }

  /**
   * Fetch a fresh Formio token from the backend.
   *
   * The returned token can be stored in localStorage and used by
   * the Formio client to authorize form loading and submission.
   */
  async refreshFormioToken(): Promise<PortalFormioTokenResponse> {
    return this.get<PortalFormioTokenResponse>('/auth/refreshToken');
  }
}
